import type { SxProps, Theme } from "@mui/material";

const important = " !important";
const wisdomMain = "wisdom.main"
export const globalStyles: Record<string, SxProps<Theme>> = {
  "@global": {
    html: {
      height: "100%",
      margin: 0,
    },
  },
  errorCard:{
    backgroundColor: wisdomMain,
    color: "confidence.T75",
  },
  errorBox:{
    backgroundColor: "confidence.T75",
  },

  root: {
    flexGrow: 1,
    color: wisdomMain,
  },
  menuButton: {
    marginRight: 2,
  },
  title: {
    flexGrow: 1,
  },
  media: {
    height: "215px",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundOrigin: "border-box"
  },
  expand: {
    marginLeft: "auto !important",
    opacity: "100% !important",
    color: "#fff !important",
    transition: `transitions.create("transform", {
      duration: transitions.duration.shortest,
    })`,
  },
  expandOpen: {
    opacity: "60% !important",
  },
  cardContent: {
    backgroundColor: "sustainability.T25",
    color: "confidence.main",
    height: "100%",
    "& > p:last-child": {
      marginBottom: 0,
    },
  },
  cardActions: {
    backgroundColor: "secondary.main",
    color: wisdomMain
  },
  card: {
    borderRadius: 2,
    height: "100%"
  },
  boldText: {
    fontWeight: 600,
  },
  searchBoxInput: {
    height: "38px",
    maxWidth: "430px",
    width: "100%",
    borderRadius: "10px",
    [`& fieldset`]: {
      borderRadius: "10px",
    },
  },
  selectedRow: {
    "& .MuiDataGrid-renderingZone": {
      "& .Mui-selected": {
        backgroundColor: "heritage.T25" + important,
        color: "confidence.main" + important,
      }
    }
  },
};

